function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var AddAppOverlayTemplate = require('./add-app.template.js');
var SaitoOverlay = require('./../../../../lib/saito/ui/saito-overlay/saito-overlay');
var InstallOverlay = require('./install-app.js');
var Transaction = require('../../../../lib/saito/transaction')["default"];
var AddAppOverlay = /*#__PURE__*/function () {
  function AddAppOverlay(app, mod) {
    var _this = this;
    _classCallCheck(this, AddAppOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.installOverlay = new InstallOverlay(app, mod);
    this.app.connection.on('saito-app-app-render-request', function () {
      _this.render();
    });
  }
  return _createClass(AddAppOverlay, [{
    key: "render",
    value: function render() {
      var _this$mod, _this$mod$attachStyle;
      var isMobile = this.app.browser.isMobileBrowser() || typeof window !== 'undefined' && window.innerWidth <= 768;

      // Same vault-style path: ensure /devtools/style.css is present before
      // drop → install confirmation (Settings/RedSquare hosts).
      (_this$mod = this.mod) === null || _this$mod === void 0 || (_this$mod$attachStyle = _this$mod.attachStyleSheets) === null || _this$mod$attachStyle === void 0 || _this$mod$attachStyle.call(_this$mod);
      this.overlay.show(AddAppOverlayTemplate(this.app, this.mod, isMobile));
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      try {
        var this_self = this;
        var isMobile = this.app.browser.isMobileBrowser() || typeof window !== 'undefined' && window.innerWidth <= 768;
        var dropPrompt = isMobile ? 'Tap to Install .saito Module' : 'Click, or Drag and Drop .saito Module to Install';
        var urlForm = document.querySelector('#saito-app-url-form');
        var urlInput = urlForm.querySelector('input');
        var urlButton = urlForm.querySelector('button');
        var dropzone = document.querySelector('#saito-app-upload');
        var dropzoneText = dropzone.querySelector('.saito-file-dropzone-text');
        var importing = false;
        var getImportUrl = function getImportUrl() {
          var value = urlInput.value.trim();
          if (!/^https?:\/\//i.test(value)) {
            return null;
          }
          try {
            var url = new URL(value);
            return url.pathname.endsWith('.saito') ? url : null;
          } catch (err) {
            return null;
          }
        };
        var updateImportButton = function updateImportButton() {
          urlButton.disabled = importing || !getImportUrl();
        };
        urlInput.addEventListener('input', updateImportButton);
        urlInput.addEventListener('change', updateImportButton);
        updateImportButton();
        var restoreDropzone = function restoreDropzone(dropzone) {
          if (!dropzone) {
            return;
          }
          dropzoneText.textContent = dropPrompt;
        };
        var importFile = function importFile(filesrc) {
          dropzoneText.textContent = 'Reading module...';
          try {
            var data = '';
            if (filesrc && filesrc.indexOf('data:application/octet-stream;base64,') >= 0) {
              data = _this2.app.crypto.base64ToString(filesrc);
            } else {
              data = typeof filesrc === 'string' ? filesrc : '';
            }
            var newtx = new Transaction();
            newtx.deserialize_from_web(this_self.app, data);
            var msg = newtx.returnMessage() || {};
            if (!msg.bin || !(msg.name || msg.slug)) {
              salert('Invalid .saito Application File');
              restoreDropzone(dropzone);
              return;
            }
            this_self.installOverlay.bin = msg.bin;
            this_self.installOverlay.categories = msg.categories;
            this_self.installOverlay.description = msg.description;
            this_self.installOverlay.image = msg.image;
            this_self.installOverlay.publisher = msg.publisher;
            this_self.installOverlay.request = msg.request;
            this_self.installOverlay.name = msg.name;
            this_self.installOverlay.version = msg.version;
            this_self.installOverlay.tx = newtx;
            this_self.installOverlay.tx_json = data;
            this_self.installOverlay.slug = msg.slug;
            this_self.installOverlay.render();
            this_self.overlay.close();
          } catch (err) {
            console.error('Error: ', err);
            salert('Invalid .saito Application File');
            restoreDropzone(dropzone);
          }
        };
        this.app.browser.addDragAndDropFileUploadToElement('saito-app-upload', function (filesrc) {
          if (!importing && urlForm.isConnected) {
            importFile(filesrc);
          }
        }, true, false, true);
        urlForm.onsubmit = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
            var url, response, filesrc, _t;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.p = _context.n) {
                case 0:
                  event.preventDefault();
                  if (!importing) {
                    _context.n = 1;
                    break;
                  }
                  return _context.a(2);
                case 1:
                  url = getImportUrl();
                  if (url) {
                    _context.n = 2;
                    break;
                  }
                  updateImportButton();
                  return _context.a(2);
                case 2:
                  importing = true;
                  urlInput.disabled = true;
                  urlButton.disabled = true;
                  urlButton.textContent = 'Importing...';
                  dropzoneText.textContent = 'Downloading module...';
                  _context.p = 3;
                  _context.n = 4;
                  return fetch(url.href, {
                    credentials: 'omit'
                  });
                case 4:
                  response = _context.v;
                  if (response.ok) {
                    _context.n = 5;
                    break;
                  }
                  throw new Error("Download failed (".concat(response.status, ")"));
                case 5:
                  _context.n = 6;
                  return response.text();
                case 6:
                  filesrc = _context.v;
                  if (urlForm.isConnected) {
                    importFile(filesrc);
                  }
                  _context.n = 8;
                  break;
                case 7:
                  _context.p = 7;
                  _t = _context.v;
                  console.error('Error downloading .saito application:', _t);
                  if (urlForm.isConnected) {
                    salert('Unable to download the .saito file. Check the URL and that the server allows cross-origin downloads, or upload the file locally.');
                  }
                case 8:
                  _context.p = 8;
                  importing = false;
                  urlInput.disabled = false;
                  updateImportButton();
                  urlButton.textContent = 'Import';
                  restoreDropzone(dropzone);
                  return _context.f(8);
                case 9:
                  return _context.a(2);
              }
            }, _callee, null, [[3, 7, 8, 9]]);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
      } catch (err) {
        console.error('Error: ', err);
        salert('An error occurred while getting application details. Check console for details.');
      }
    }
  }]);
}();
module.exports = AddAppOverlay;